import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { de as deLocale } from 'date-fns/locale/de';
import { enUS as enLocale } from 'date-fns/locale/en-US';
import { es as esLocale } from 'date-fns/locale/es';
import { fr as frLocale } from 'date-fns/locale/fr';
import { it as itLocale } from 'date-fns/locale/it';

/** The locales the v2 date pickers explicitly support. */
export type DateLocale = 'en' | 'de' | 'fr' | 'es' | 'it';

// Weeks start on Monday in every locale, en-US included, as Luminovo's European users expect.
const withMondayStart = <T extends typeof enLocale>(locale: T): T => ({
    ...locale,
    options: { ...locale.options, weekStartsOn: 1 },
});

const DATE_FNS_LOCALE_BY_DATE_LOCALE: Record<DateLocale, typeof enLocale> = {
    en: withMondayStart(enLocale),
    de: withMondayStart(deLocale),
    fr: withMondayStart(frLocale),
    es: withMondayStart(esLocale),
    it: withMondayStart(itLocale),
};

/** The `date-fns` locale and adapter for `LocalizationProvider`. */
export function dateFnsAdapterFor(locale: DateLocale): {
    adapter: typeof AdapterDateFns;
    dateFnsLocale: typeof enLocale;
} {
    return {
        adapter: AdapterDateFns,
        dateFnsLocale: DATE_FNS_LOCALE_BY_DATE_LOCALE[locale],
    };
}

/** English for any locale the pickers don't support. */
export function resolveDateLocale(locale: string | null | undefined): DateLocale {
    switch (locale) {
        case 'de':
        case 'fr':
        case 'es':
        case 'it':
            return locale;
        default:
            return 'en';
    }
}
